<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row justify="center" class="mt-n5">
          <span style="font-size: 34px; color: #616161">DGII</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" sm="6" xl="4">
        <v-card
          @click="(selectedReport = 606), (dialog = true)"
          class="mx-auto"
          color="#E91E63"
        >
          <v-card-title class="white--text"> Reporte 606 </v-card-title>
          <v-card-subtitle class="white--text"
            >(Compra de Bienes y Servicios)</v-card-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="12" md="4" sm="6" xl="4">
        <v-card
          @click="(selectedReport = 607), (dialog = true)"
          class="mx-auto"
          color="#673AB7"
        >
          <v-card-title class="white--text"> Reporte 607 </v-card-title>
          <v-card-subtitle class="white--text"
            >(Ventas de Bienes y Servicios)</v-card-subtitle
          >
        </v-card>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-dialog width="1000" v-model="dialog">
      <v-card>
        <v-card-title class="text-h5"
          >Reporte {{ selectedReport }}</v-card-title
        >
        <v-card-text>
          <search-header
            @dataFilters="changeBusiness($event)"
            :show_weeks="true"
            :show_location="false"
            :show_department="false"
            :show_refresh="false"
            :selected_week="4"
            :type="false"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="green darken-1"
            text
            :loading="loading"
            @click="generateReport"
            >Generar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Resultado -->
    <v-row v-if="report" class="mt-2">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Reporte {{ report.type }} — {{ report.business_unit }} — Período
            {{ report.period }}
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              class="mr-2"
              small
              :disabled="exportRows.length === 0"
              @click="downloadExcel"
            >
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Excel (Formato DGII)
            </v-btn>
            <v-btn
              color="primary"
              small
              :disabled="exportRows.length === 0"
              @click="downloadTxt"
            >
              <v-icon left small>mdi-file-document-outline</v-icon>
              TXT (Envío DGII)
            </v-btn>
          </v-card-title>

          <v-card-subtitle>
            <v-chip class="mr-2" small color="blue lighten-4">
              {{ report.rows.length }} registros
            </v-chip>
            <v-chip class="mr-2" small color="green lighten-4">
              Monto facturado:
              {{ formatMoney(totalFacturado) }}
            </v-chip>
            <v-chip class="mr-2" small color="teal lighten-4">
              ITBIS facturado: {{ formatMoney(totalItbis) }}
            </v-chip>
            <v-chip
              v-if="rowsSinNcf.length > 0"
              class="mr-2"
              small
              color="orange lighten-4"
            >
              {{ rowsSinNcf.length }} sin NCF (excluidos del archivo)
            </v-chip>
            <v-chip
              v-if="rowsSinRnc.length > 0"
              small
              color="red lighten-4"
            >
              {{ rowsSinRnc.length }} sin RNC/Cédula
            </v-chip>
          </v-card-subtitle>

          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="report.rows"
              :items-per-page="15"
              dense
              class="elevation-1 dgii-table"
              :footer-props="{ 'items-per-page-options': [15, 50, 100, -1] }"
            >
              <template v-slot:item="{ item }">
                <tr :class="{ 'row-warning': !item.ncf || !item.rnc_cedula }">
                  <td v-for="h in tableHeaders" :key="h.value" class="text-no-wrap">
                    <span v-if="h.money">{{ formatMoney(item[h.value]) }}</span>
                    <span v-else>{{ item[h.value] }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ExcelJS from "exceljs";

moment.locale("es");

// Plantilla oficial DGII — Formato 606 (Norma General 07-2018)
const COLUMNS_606 = [
  { header: "RNC o Cédula", value: "rnc_cedula" },
  { header: "Tipo Id", value: "tipo_id" },
  { header: "Tipo Bienes y Servicios Comprados", value: "tipo_bienes_servicios" },
  { header: "NCF", value: "ncf" },
  { header: "NCF ó Documento Modificado", value: "ncf_modificado" },
  { header: "Fecha Comprobante", value: "fecha_comprobante" },
  { header: "Fecha Pago", value: "fecha_pago" },
  { header: "Monto Facturado en Servicios", value: "monto_servicios", money: true },
  { header: "Monto Facturado en Bienes", value: "monto_bienes", money: true },
  { header: "Total Monto Facturado", value: "total_monto_facturado", money: true },
  { header: "ITBIS Facturado", value: "itbis_facturado", money: true },
  { header: "ITBIS Retenido", value: "itbis_retenido", money: true },
  { header: "ITBIS sujeto a Proporcionalidad (Art. 349)", value: "itbis_proporcionalidad", money: true },
  { header: "ITBIS llevado al Costo", value: "itbis_costo", money: true },
  { header: "ITBIS por Adelantar", value: "itbis_adelantar", money: true },
  { header: "ITBIS percibido en compras", value: "itbis_percibido", money: true },
  { header: "Tipo de Retención en ISR", value: "tipo_retencion_isr" },
  { header: "Monto Retención Renta", value: "monto_retencion_renta", money: true },
  { header: "ISR Percibido en compras", value: "isr_percibido", money: true },
  { header: "Impuesto Selectivo al Consumo", value: "impuesto_selectivo", money: true },
  { header: "Otros Impuestos/Tasas", value: "otros_impuestos", money: true },
  { header: "Monto Propina Legal", value: "propina_legal", money: true },
  { header: "Forma de Pago", value: "forma_pago" },
];

// Plantilla oficial DGII — Formato 607 (Norma General 07-2018)
const COLUMNS_607 = [
  { header: "RNC/Cédula o Pasaporte", value: "rnc_cedula" },
  { header: "Tipo Identificación", value: "tipo_id" },
  { header: "Número Comprobante Fiscal", value: "ncf" },
  { header: "Número Comprobante Fiscal Modificado", value: "ncf_modificado" },
  { header: "Tipo de Ingreso", value: "tipo_ingreso" },
  { header: "Fecha Comprobante", value: "fecha_comprobante" },
  { header: "Fecha de Retención", value: "fecha_retencion" },
  { header: "Monto Facturado", value: "monto_facturado", money: true },
  { header: "ITBIS Facturado", value: "itbis_facturado", money: true },
  { header: "ITBIS Retenido por Terceros", value: "itbis_retenido_terceros", money: true },
  { header: "ITBIS Percibido", value: "itbis_percibido", money: true },
  { header: "Retención Renta por Terceros", value: "retencion_renta_terceros", money: true },
  { header: "ISR Percibido", value: "isr_percibido", money: true },
  { header: "Impuesto Selectivo al Consumo", value: "impuesto_selectivo", money: true },
  { header: "Otros Impuestos/Tasas", value: "otros_impuestos", money: true },
  { header: "Monto Propina Legal", value: "propina_legal", money: true },
  { header: "Efectivo", value: "efectivo", money: true },
  { header: "Cheque/ Transferencia/ Depósito", value: "cheque_transferencia", money: true },
  { header: "Tarjeta Débito/Crédito", value: "tarjeta", money: true },
  { header: "Venta a Crédito", value: "credito", money: true },
  { header: "Bonos o Certificados de Regalo", value: "bonos", money: true },
  { header: "Permuta", value: "permuta", money: true },
  { header: "Otras Formas de Ventas", value: "otras", money: true },
];

export default {
  data: () => ({
    dialog: false,
    loading: false,
    selectedReport: null,
    report: null,
    filters: {
      business: "",
      location: null,
      department_id: "",
      routes: "",
      dateStart: moment().format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
    },
  }),
  computed: {
    dgiiColumns() {
      if (!this.report) return [];
      return this.report.type === 606 ? COLUMNS_606 : COLUMNS_607;
    },
    tableHeaders() {
      const extra = [
        { text: "Origen", value: "source" },
        { text: "Documento", value: "internal_number" },
        { text: "Entidad", value: "entity_name" },
      ];
      return [
        ...extra,
        ...this.dgiiColumns.map((c) => ({
          text: c.header,
          value: c.value,
          money: c.money || false,
          sortable: false,
        })),
      ];
    },
    // La DGII no acepta registros sin NCF: se excluyen del archivo de envío
    exportRows() {
      if (!this.report) return [];
      return this.report.rows.filter((r) => r.ncf);
    },
    rowsSinNcf() {
      return this.report ? this.report.rows.filter((r) => !r.ncf) : [];
    },
    rowsSinRnc() {
      return this.report ? this.report.rows.filter((r) => !r.rnc_cedula) : [];
    },
    totalFacturado() {
      if (!this.report) return 0;
      const field =
        this.report.type === 606 ? "total_monto_facturado" : "monto_facturado";
      return this.report.rows.reduce((s, r) => s + (Number(r[field]) || 0), 0);
    },
    totalItbis() {
      if (!this.report) return 0;
      return this.report.rows.reduce(
        (s, r) => s + (Number(r.itbis_facturado) || 0),
        0
      );
    },
  },
  methods: {
    changeBusiness(filters) {
      this.filters = filters;
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async generateReport() {
      if (this.selectedReport == null) {
        this.$toast.error("Debe seleccionar un reporte");
        return;
      }
      if (this.filters.business == null || this.filters.business === "") {
        this.$toast.error("Debe seleccionar una empresa");
        return;
      }
      this.loading = true;
      try {
        const response = await this.api_Post("accounting/dgii_report", {
          business_unit_id: this.filters.business,
          type: this.selectedReport,
          dateStart: this.filters.dateStart,
          dateEnd: this.filters.dateEnd,
        });
        const data = await response.json();
        if (response.status !== 200) {
          this.$toast.error(data.message || "Error generando el reporte");
          return;
        }
        this.report = data;
        this.dialog = false;
        if (data.rows.length === 0) {
          this.$toast.warning("No se encontraron registros en el período");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Error generando el reporte");
      } finally {
        this.loading = false;
      }
    },
    async downloadExcel() {
      const { type, rnc, period } = this.report;
      const columns = this.dgiiColumns;
      const rows = this.exportRows;

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(`${type}`);

      // Encabezado de la plantilla DGII
      worksheet.getCell("A1").value = "RNC o Cédula";
      worksheet.getCell("B1").value = rnc;
      worksheet.getCell("A2").value = "Periodo";
      worksheet.getCell("B2").value = period;
      worksheet.getCell("A3").value = "Cantidad Registros";
      worksheet.getCell("B3").value = rows.length;
      worksheet.getCell("A4").value = "Total Monto Facturado";
      worksheet.getCell("B4").value =
        Math.round(
          rows.reduce(
            (s, r) =>
              s +
              (Number(
                r[type === 606 ? "total_monto_facturado" : "monto_facturado"]
              ) || 0),
            0
          ) * 100
        ) / 100;
      for (let i = 1; i <= 4; i++) {
        worksheet.getCell(`A${i}`).font = { bold: true };
      }

      // Numeración y títulos de columnas (filas 6 y 7 de la plantilla)
      const numberRow = worksheet.getRow(6);
      const headerRow = worksheet.getRow(7);
      columns.forEach((c, idx) => {
        numberRow.getCell(idx + 1).value = idx + 1;
        headerRow.getCell(idx + 1).value = c.header;
      });
      [numberRow, headerRow].forEach((row) => {
        row.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: type === 606 ? "FFC2185B" : "FF512DA8" },
          };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
      headerRow.height = 45;

      rows.forEach((r) => {
        const row = worksheet.addRow(columns.map((c) => (c.money ? Number(r[c.value]) || 0 : r[c.value] || "")));
        columns.forEach((c, idx) => {
          if (c.money) row.getCell(idx + 1).numFmt = "#,##0.00";
        });
      });

      worksheet.columns.forEach((col) => {
        col.width = 16;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `DGII_F_${type}_${rnc}_${period}.xlsx`;
      link.click();
    },
    downloadTxt() {
      const { type, rnc, period } = this.report;
      const columns = this.dgiiColumns;
      const rows = this.exportRows;

      const lines = [`${type}|${rnc}|${period}|${rows.length}`];
      rows.forEach((r) => {
        lines.push(
          columns
            .map((c) => {
              const v = r[c.value];
              if (c.money) return (Number(v) || 0).toFixed(2);
              return v == null ? "" : String(v);
            })
            .join("|")
        );
      });

      const blob = new Blob([lines.join("\r\n")], {
        type: "text/plain;charset=utf-8",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `DGII_F_${type}_${rnc}_${period}.txt`;
      link.click();
    },
  },
};
</script>

<style scoped>
.dgii-table >>> table {
  min-width: 2800px;
}
.dgii-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
.row-warning {
  background-color: #fff3e0;
}
</style>
